import React, { useState } from 'react';

function App() {
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);

  // Dynamically set backend URL to current host's IP + port 3001
  const backendUrl = `http://${window.location.hostname}:3001`;

  const handleSearch = async () => {
    if (!search) return;

    try {
      const res = await fetch(`${backendUrl}/search/${search}`);
      const data = await res.json();
      if (data.status === 'success') {
        setResults(data.files);
      } else {
        alert('No PDF found for this ID');
        setResults([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Failed to connect to server. Please check backend status.');
    }
  };

  // Handle Enter key press
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Search by MRN ID (e.g., 148318)</h2>
      <input
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Enter MRN"
        style={{ width: 200, marginRight: 10 }}
      />
      <button onClick={handleSearch}>Search</button>

      {results.length > 0 && (
        <table border="1" style={{ marginTop: 20, width: '100%' }}>
          <thead>
            <tr>
              <th>PDF Name</th>
              <th>Modified Date</th>
              <th>Open</th>
            </tr>
          </thead>
          <tbody>
            {results.map((file, index) => (
              <tr key={index}>
                <td>{file.name}</td>
                <td>{new Date(file.modified).toLocaleString()}</td>
                <td>
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View PDF
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default App;
